<template>
  <div v-if="application && $store.state.App.states">
    <prequalification-form ref="prequal"
                           :program="application.program"
                           :google-api-key="$store.state.App.env.GOOGLE_API_KEY"
                           :states="$store.state.App.states"
                           :counties="$store.state.App.counties"
    ></prequalification-form>
    <div class="app-wizard-page" v-if="application.status.allow_household_edit">
      <div id="apply-area" class="">
        <div class="uk-grid" >
          <div class="uk-width-1-1">
            <div class="uk-vertical-align uk-text-center uk-cover-background uk-animation-fade uk-animation-5 " id="section-top-bg">
              <div class="uk-vertical-align-middle uk-width-9-10 uk-width-medium-2-3 uk-contrast">
                <p class="uk-visible-small">&nbsp;</p>
                <h1 class=" uk-margin-small-top" data-uk-scrollspy="{cls:'uk-animation-fade', delay:500}" >
                  <strong>{{ application.program.program_name }} Section {{currentStep}}:</strong>
                  <span v-if="currentStepObject">{{ currentStepObject.title }}</span>
                </h1>
                <div class="uk-progress uk-progress-success uk-progress-striped uk-active">
                  <div class="uk-progress-bar" :style="{width: `${progressPercent}%`, backgroundColor: programSettings['primary-program-color']}"><span>{{ progressPercent }}%</span></div>
                </div>
                <p class="uk-text-small uk-align-center">YOUR PROGRESS</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-container">
        <div class="uk-grid" id="section-nav">
          <div class="uk-width-1-1 uk-margin-small-bottom">
            <form-wizard
              @on-complete="onComplete"
              @on-change="onStepChange"
              @on-error="onStepError"
              title=""
              subtitle=""
              :color="programSettings['primary-program-color']"
            >
              <tab-content
                :title="step.title"
                v-for="(step, index) in steps"
                :key="index"
                :before-change="() => validateStep(index)"
                icon="uk-icon-dot-circle-o uk-icon-tiny"
              >
                <component
                  :is="step.component"
                  :ref="step.key"
                  @done="stepUpdated"
                  @loading="loadingState"
                  @setLastStep="setLastStep"
                />
              </tab-content>
              <div class="uk-text-danger uk-width-1-1 uk-text-right" v-if="showErrorMessage">Sorry, there seems to be some errors on your form. Please check your entries and try again.</div>
              <template slot="footer" slot-scope="props">
                <div class="wizard-footer-left">
                  <wizard-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab();" :style="props.fillButtonStyle">Previous</wizard-button>
                </div>
                <div class="wizard-footer-right">
                  <div>
                    <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab();" :style="props.fillButtonStyle" class="wizard-footer-right uk-button ">Save &amp; Continue</wizard-button>
                    <wizard-button v-else @click.native="onComplete" :style="props.fillButtonStyle" class="wizard-footer-right finish-button uk-button uk-button-primary">{{props.isLastStep ? 'Complete' : 'Save &amp; Continue'}}</wizard-button>

                  </div>
                </div>
              </template>
            </form-wizard>
          </div>
        </div>
      </div>

      <modal-dialog title="Are you sure?"
                    ref="confirmSubmitDialog"
                    @confirm="onCompleteModalConfirm">
        Submitting your application will remove your ability to change or update any answers or documents.
        Any missing data or documents will delay the processing of your application. Are you sure you are
        ready to submit your application?
      </modal-dialog>

    </div>
    <div v-else class="uk-container">
      <div class="uk-grid">
        <div class="uk-width-4-5 uk-align-center">
          <h1>This application is locked for editing.</h1>
          <h2>Status: {{ application.status.program_application_status_name }}</h2>
          <h3>{{ application.status.description }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {FormWizard, TabContent, WizardButton} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import ModalDialog from "../../components/Common/ModalDialog";
  import {mapGetters, mapState} from "vuex";

  export default {
    name: "AppWizard",
    props: ['id'],
    components: {
      ModalDialog,
      FormWizard,
      TabContent,
      WizardButton,
    },
    data() {
      return {
        loading: false,
        showErrorMessage: false,
        currentStep: 1,
        props: {
          title: '',
          subtitle: '',
        },
      }
    },
    mounted() {
      this.loading = true;
      if (this.user)
      {
        this.fetchApplication(this.id)
      }


    },
    watch: {
      user: {
        deep: true,
        handler(newVal, oldVal) {
          if (!oldVal && newVal)
          this.fetchApplication(this.id)
        }
      },
      loading: {
        handler: function(newValue, oldValue) {
          // this.$isLoading(newValue)
        },
      }
    },

    computed: {
      currentStepObject() {
        let currentStepKey = 'step'+this.currentStep;
        for(var i in this.steps) {
          if(this.steps[i].key == currentStepKey) {
            return this.steps[i];
          }
        }
      },
      user() {
        return this.$store.getters['App/user']
      },
      progressPercent() {
        return Math.ceil(100 / this.steps.length * (this.currentStep-1))
      },
      ...mapState('App', {
        env: state => state.env,
        permissions: state => state.permissions,
      }),
      ...mapState('Application', {
        application: state => state.application,
      }),
      ...mapGetters('Application', [ 'steps', 'programSettings' ])
    },

    methods: {
      setLastStep(step) {
        if(step === 'current') {
          this.$store.commit('Application/setLastStep', this.currentStep);
        } else if(step !== null && step !== undefined) {
          this.$store.commit('Application/setLastStep', step);
        }else {
          this.$store.commit('Application/setLastStep', null);
        }
      },
      setLoading(val)
      {
        this.loading = val
      },
      fetchApplication(id)
      {
        this.$store
          .dispatch('Application/fetch', id)
          .then((res) => {
            this.loading = false
            if(!this.application.prequal_answers && this.application.program.settings['requires-prequalification-questions']) {
              this.$refs.prequal.showForApplication(this.application);
            }

            // If Progress
            if(this.application.unit_ledger_entries.length > 0) {
              UIkit.modal.alert('It looks like you\'re coming back to finish your application.  Please review each page for accuracy and then click "Save and Continue" until you are where you last saved.')
            }


          })
          .catch((error) => {
            this.loading = false
          })
        this.$store
          .dispatch('Application/fetchVendorList', id)
      },
      loadingState(loading) {

      },
      async onComplete() {
        if(await this.validateStep(this.currentStep-1)) {
          this.$refs.confirmSubmitDialog.open();
        }
      },
      async onCompleteModalConfirm() {
        this.setLoading(true)
        await this.$store.dispatch('Application/markComplete');
        await this.$store.dispatch('Application/fetch', this.id)

        this.$store.dispatch('App/fetchUser').then(res => {
          this.setLoading(false)
          this.$router.replace('/');
        });
      },
      scrollTop: function () {
        window.scrollTo(0,0);
      },
      onStepChange(prevIndex, nextIndex) {
        this.currentStep = nextIndex + 1;
        this.scrollTop();
        this.setLoading(false)
        this.showErrorMessage = false;

      },
      onStepError(error) {
        console.log(error)
        if (error)
          this.setLoading(false)
      },
      stepUpdated() {
      },
      async validateStep(index) {
        let stepValid = false;
        this.setLoading(true)
        const step = this.steps[index]
        console.log('validating step: ', step, this.$refs);
        if (this.$refs[step.key] && this.$refs[step.key][0] && this.$refs[step.key][0].validateStep)
        {
          stepValid = await this.$refs[step.key][0].validateStep();
          console.log('step is valid', stepValid);

          if(!stepValid) {
              UIkit.modal.alert('<div class=\'uk-grid\'><div class=\'uk-width-1-1 uk-margin-bottom\'><h3>Please correct all errors on this application step before proceeding.</h3></div></div>');
          }
        } else {
          stepValid = true;
        }
        this.setLoading(false);

        return stepValid
      }
    }
  }
</script>

<style  lang="scss">
  .uk-progress-bar {
    background-color: #589fd2;
    padding-left: 0px;
    padding-right: 0px;
    & > span {
      padding-left: 10px;
    }
  }
  .agreement-container {
    padding: 20px;

    .agreement-title {
      font-size: 1.3em;
    }

    .uk-block-default {
      background-color: #efefef;
      padding: 20px 20px;
    }
  }

  @media only screen and (max-width: 600px) {
    .vue-form-wizard.md .wizard-icon-circle {
      width: 50px;
      height: 50px;
      font-size: 18px;

    }
    .stepTitle {
      font-size: 12px;
      padding: 2px;
    }

    .wizard-progress-with-circle {
      top: 30px !important;
    }

    .wizard-nav.wizard-nav-pills li {
      width: 25% !important;
    }
  }
</style>
